module.exports = __webpack_public_path__ + "img/virtue-virtual.caca27eb.jpg";